import React from 'react';
import { createStyles, makeStyles, Typography, Box } from '@material-ui/core';
import { useTranslation } from '../../../../../hooks/useTranslation';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      margin: '1rem 0 .5rem 0',
      textAlign: 'center',
    },
  }),
);

interface Props {
  lastupdated: string;
}

export const PersonalSummaryBlock = (props: Props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { lastupdated } = props;

  return (
    <Box className={classes.container}>
      <Typography variant="subtitle2" data-testid="OMP-LastUpdated">
        {t('MAP_LAST_UPDATED')}: {lastupdated}
      </Typography>
      <Typography variant="subtitle1" data-testid="OMP-UpdateInterval">
        {t('INFORMATION_UPDATES_EVERY')}
      </Typography>
    </Box>
  );
};

export default PersonalSummaryBlock;
